/** @jsx jsx */

/** @jsxFrag React.Fragment*/
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { CitationModule } from '@coursera-web/cds-labs';

import FrontPageModulesRenderer from 'bundles/front-page/components/FrontPageModulesRenderer';
import SpotlightCollectionModuleDelegator from 'bundles/front-page/components/SpotlightCollectionModuleDelegator';
import { useFrontPageContentData } from 'bundles/front-page/providers/FrontPageContentDataProvider';
import OnboardingModuleRenderer from 'bundles/front-page/redesign-modules/OnboardingModuleRenderer';
import AiModuleRenderer from 'bundles/front-page/redesign-modules/ai-assistance/AiModuleRenderer';
import AiSearchModuleRenderer from 'bundles/front-page/redesign-modules/ai-search/AiSearchModuleRenderer';
import CareerAcademyModuleRedesignModuleRenderer from 'bundles/front-page/redesign-modules/career-academy/CareerAcademyModuleRedesignModuleRenderer';
import CompactCollectionsModuleRenderer from 'bundles/front-page/redesign-modules/compact-collections/CompactCollectionsModuleRenderer';
import {
  getPopularAndTrendingCollectionData,
  getPopularByCategoryCollectionData,
} from 'bundles/front-page/redesign-modules/compact-collections/data/getCompactCollections';
import DomainsModuleRenderer from 'bundles/front-page/redesign-modules/domains/DomainsModuleRenderer';
import HeroBannerModuleRenderer from 'bundles/front-page/redesign-modules/hero-banner/HeroBannerModuleRenderer';
import MerchandisingBucketsModuleRenderer from 'bundles/front-page/redesign-modules/merchandising-buckets/MerchandisingBucketsModuleRenderer';
import PartnerLogosModuleRenderer from 'bundles/front-page/redesign-modules/partner-logos/PartnerLogosModuleRenderer';
import PromoUnitsDelegator from 'bundles/front-page/redesign-modules/promo-units/PromoUnitsDelegator';
import SpotlightCollectionsModuleRenderer from 'bundles/front-page/redesign-modules/spotlight-collections/SpotlightCollectionsModuleRenderer';
import TestimonialsModuleRenderer from 'bundles/front-page/redesign-modules/testimonials/TestimonialsModuleRenderer';
import getCertificationPrepSpotlightCollectionsData from 'bundles/front-page/utils/getCertificationPrepSpotlightCollections';
import { getPathwayDisclaimer } from 'bundles/unified-common/utils/getPathwaysDisclaimers';

const styles = {
  container: css`
    margin-top: var(--cds-spacing-200);
  `,
};

// Page content of LOHP Redesign Q3 2025
const FrontPageContent = () => {
  const { modules, loading } = useFrontPageContentData();

  if (loading) return null;

  let frontPageContentOutput;

  if (modules && modules.length > 0) {
    frontPageContentOutput = <FrontPageModulesRenderer modules={modules} />;
  } else {
    frontPageContentOutput = (
      <>
        <HeroBannerModuleRenderer />
        <MerchandisingBucketsModuleRenderer />
        <PartnerLogosModuleRenderer />
        <CompactCollectionsModuleRenderer
          {...getPopularAndTrendingCollectionData()}
          dataTestId="compact-collections-1"
        />
        <DomainsModuleRenderer />
        <SpotlightCollectionModuleDelegator isFirstSpotlightCollectionModule dataTestId="spotlight-collections-1" />
        <CareerAcademyModuleRedesignModuleRenderer />
        <OnboardingModuleRenderer />
        <SpotlightCollectionsModuleRenderer
          {...getCertificationPrepSpotlightCollectionsData()}
          dataTestId="spotlight-collections-2"
        />
        <CompactCollectionsModuleRenderer
          {...getPopularByCategoryCollectionData()}
          dataTestId="compact-collections-2"
        />
        <PromoUnitsDelegator />
        <TestimonialsModuleRenderer />
      </>
    );
  }

  return (
    <main className="rc-FrontPageWrapper cds" data-catchpoint="front-page-application" data-e2e="cms-lohp-content">
      <div css={styles.container}>
        <AiSearchModuleRenderer />
        <AiModuleRenderer />
        {frontPageContentOutput}
        <CitationModule citations={getPathwayDisclaimer()} removeBottomPadding />
      </div>
    </main>
  );
};

export default FrontPageContent;
